import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  changeUserPassword( {dispatch}, obj) {
    return new Promise((resolve, reject) => {
      axios.post('/admin/change-password', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  }, 
}
